import { deserializeDirectionsData } from "@lib/directionsSerializer";
import { logWarning } from "@lib/logger";
import { selectSelectedEntity } from "@store/map/mapReducer";
import { useAppSelector } from "@store/store";
import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import { FunctionComponent, useEffect } from "react";
import { getMapPadding } from "../calculateMapBounds";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";

/**
 * Display route for an entity with cached routing data, such as Tour.
 */
const EntityRoute: FunctionComponent = () => {
  const map = useMap();
  const routesLib = useMapsLibrary("routes");
  const geometryLib = useMapsLibrary("geometry");
  const selectedEntity = useAppSelector(selectSelectedEntity);
  const { isMobile } = useWindowSize();

  useEffect(() => {
    if (
      !routesLib ||
      !map ||
      !geometryLib ||
      !selectedEntity?.entity?.directionsData
    ) {
      return;
    }

    const directionsRenderer = new routesLib.DirectionsRenderer({
      map,
      suppressMarkers: true,
      preserveViewport: true,
      polylineOptions: {
        strokeColor: VisitWidget.settings.currentClientRouteColor,
        strokeWeight: 4,
      },
    });

    try {
      const directions = deserializeDirectionsData(
        selectedEntity.entity.directionsData,
      );
      directionsRenderer.setDirections(directions);
      map.fitBounds(directions.routes[0].bounds, getMapPadding(isMobile));
    } catch (error) {
      logWarning(error);
    }

    return () => {
      directionsRenderer.setMap(null);
    };
  }, [isMobile, map, routesLib, selectedEntity, geometryLib]);

  return <></>;
};

export { EntityRoute };
